<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :label="label"
    :loading="loading"
    :search-input.sync="search"
    multiple
    chips
    clearable
    item-value="id"
    item-text="name"
    outlined
    dense
    prepend-icon="local_taxi"
    placeholder="Search services..."
    cache-items
  >
    <template slot="selection" slot-scope="data">
      <v-chip
        :selected="data.selected"
        close
        @input="remove(data.item.id)"
        small
        color="primary"
      >
        {{ data.item.name }}
      </v-chip>
    </template>
    <template slot="item" slot-scope="data">
      <v-list-tile-content>
        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "RidesServiceFilter",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "Services",
    },
  },
  data() {
    return {
      model: [],
      search: null,
      loading: false,
      items: [],
      searchTimeout: null,
    };
  },
  watch: {
    value(newVal) {
      if (Array.isArray(newVal)) {
        // If values are IDs, keep them as is
        this.model = newVal;
      } else {
        this.model = [];
      }
    },
    model(newVal) {
      this.$emit("input", newVal || []);
    },
    search(val) {
      if (val === null || val === undefined) {
        // Load initial data when search is cleared
        this.loadData("");
        return;
      }
      // Debounce search
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.loadData(val);
      }, 300);
    },
  },
  mounted() {
    // Initialize model from value
    if (Array.isArray(this.value)) {
      this.model = this.value;
    }
    // Load initial data
    this.loadData("");
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  methods: {
    loadData(searchVal) {
      this.loading = true;
      const params = new URLSearchParams();
      if (searchVal) {
        params.append("search", searchVal);
      }
      this.axios
        .get(this.api.ACTIONS.SERVICES, { params })
        .then((res) => {
          const responseData = res.data.data;
          // Handle paginated response
          const data = responseData && responseData.data ? responseData.data : (Array.isArray(responseData) ? responseData : []);
          this.items = data.map((item) => ({
            id: item.id,
            name: item.name || item.name_en || item.name_ar || 'Unknown',
            ...item,
          }));
        })
        .catch((err) => {
          console.log(err);
          this.items = [];
        })
        .finally(() => (this.loading = false));
    },
    remove(id) {
      this.model = this.model.filter((item) => item !== id);
    },
  },
};
</script>

<style scoped>
</style>

